import * as types from "../types";
import backend from "../api/api";
import history from "../history";
import { store } from "../store";
import { message } from "antd";

const getConfig = () => {
  const token = store.getState().auth.token;

  const config = {
    headers: {
      Authorization: `Token ${token}`,
    },
  };

  return config;
};

export const createUserDocument = (formValues) => async (dispatch) => {
  try {
    const response = await backend.post(
      "api/contact/employee-document/",
      formValues,
      getConfig()
    );
    // if (response.status === 201) {
    //   dispatch({
    //     type: types.CREATE_USER_ROLE,
    //     payload: { ...response.data },
    //   });
    //   message.success(
    //     formValues["name"] + " Has been added to your Role list"
    //   );
    //   history.push("/employee");
    // }
  } catch (error) {
    alert(error);
  }
};

export const getAllUserDocument = () => async (dispatch) => {
  try {
    const response = await backend.get("api/contact/employee-document/", getConfig());
    if (response.status === 200) {
      dispatch({
        type: types.GET_ALL_USER_ROLE,
        payload: response.data,
      });
    }
  } catch (error) {
    console.log(error);
  }
};

export const deleteUserDocument = (id) => async (dispatch) => {
  try {
    const response = await backend.delete(
      `api/contact/employee-document/${id}/`,
      getConfig()
    );
    if (response.status === 204) {
      dispatch({ type: types.DELETE_USER_ROLE, payload: id });
    }
    history.push("/employee");
  } catch (error) {
    alert(error);
  }
};

export const updateUserDocument = (id, formValues) => async (dispatch) => {
  try {
    const response = await backend.patch(
      `api/contact/employee-document/${id}/`,
      formValues,
      getConfig()
    );
    if (response.status === 200) {
      dispatch({ type: types.UPDATE_USER_ROLE, payload: { ...response.data } });
    }
    history.push("/employee");
    message.success("Updated Successfully");
  } catch (error) {
    alert(error.response);
  }
};